import { create } from 'zustand'

export type QuickCreateInitial = {
  name?: string
  category?: string
  localVariant?: boolean
}

type QuickCreateState = {
  open: boolean
  initial: QuickCreateInitial
  openDrawer: (initial?: QuickCreateInitial) => void
  closeDrawer: () => void
}

export const useQuickCreateStore = create<QuickCreateState>((set) => ({
  open: false,
  initial: {},
  openDrawer: (initial = {}) => set({ open: true, initial }),
  closeDrawer: () => set({ open: false, initial: {} }),
}))
